var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2425 6.58575L9.41406 3.75732L3.9713 9.20008C3.8317 9.33968 3.73655 9.51748 3.69783 9.71107L3.0501 12.9497L6.28874 12.302C6.48233 12.2633 6.66013 12.1681 6.79973 12.0285L12.2425 6.58575Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.828 2.34309C11.2186 1.95257 11.8517 1.95257 12.2423 2.34309L13.6565 3.75731C14.047 4.14783 14.047 4.781 13.6565 5.17152L12.9494 5.87863L10.1209 3.0502L10.828 2.34309Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.8cb1cd062281cae7cb5d89a930f0a256.svg";
export { ForwardRef as ReactComponent };